import type { CSSProperties } from "react";
import React from "react";
import cn from "classnames";

import type { TSpriteIconsProps } from "../types";

import styles from "./SpriteIcon.module.scss";

const CDN_PATH = "https://cdn.litres.ru/assets/icons";

export const SpriteIcon = (props: TSpriteIconsProps) => {
  const getStyle = (w: number, h: number, s: string): CSSProperties => ({
    WebkitMaskImage: `url(${CDN_PATH}/${props.name}${s}.svg)`,
    maskImage: `url(${CDN_PATH}/${props.name}${s}.svg)`,
    width: `${w}px`,
    height: `${h}px`,
    WebkitFlex: `0 0 ${w}px`,
    flex: `0 0 ${w}px`,
  });

  let style: CSSProperties | undefined;
  if ("size" in props) {
    style = getStyle(props.size, props.size, `${props.size}`);
  } else {
    style = getStyle(props.width, props.height, ``);
  }

  return (
    <div
      className={cn(styles.icon, props.className)}
      onClick={props.onClick}
      title={props.title}
      data-testid={props["data-testid"] || `icon_${props.name}`}
      style={style}
      role="presentation"
    />
  );
};
